<template>
  <div>
    <van-tabs v-model="active" animated="">
      <van-tab title="11111"
        >气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发气温日光IQ机器人屏蔽盖IQ发
      </van-tab>
      <van-tab title="22222">asda</van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
    };
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/content/Test.vue